import { roles } from "constants/index";

export const rolesShowPosition = [roles.admin, roles.departmentManager]

export const rolesEdit = [roles.admin, roles.departmentManager, roles.springer, roles.regionManager, roles.viceRegionManager]

export const rolesDelete = [roles.admin]

export const rolesChangeStore = [roles.staff, roles.staffShop]

export const rolesNotChangeStore = [roles.shopManager, roles.staff, roles.staffShop, roles.springer]

export const rolesChangePw = [roles.admin]

export const rolesNotChangePw = [roles.staff, roles.staffShop, roles.springer]

export const rolesShowDetailTimeSheet = [roles.staff, roles.staffShop, roles.springer]

export const rolesAddEmployee = [roles.admin, roles.departmentManager]